import * as S from "./styles";
import { ButtonProps, CircularProgress } from "@mui/material";

interface BtnProps extends ButtonProps {
  children: React.ReactNode | string;
  isLoading?: boolean;

}

export function FutButton({ children, isLoading, ...rest }: BtnProps) {
  return isLoading ? (
    <S.LoadingContainer>
      <CircularProgress />
    </S.LoadingContainer>
  ) : (
    <S.ButtonStyled {...rest}>{children}</S.ButtonStyled>
  );
}
